import { render, staticRenderFns } from "./CustomFileComponent.vue?vue&type=template&id=a7916652&scoped=true&"
import script from "./CustomFileComponent.vue?vue&type=script&lang=js&"
export * from "./CustomFileComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomFileComponent.vue?vue&type=style&index=0&id=a7916652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7916652",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VFileInput})
